"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("reflect-metadata");

var SCHEMA_KEY = Symbol('class-validator-jsonschema:JSONSchema');

function JSONSchema(schema) {
  return function (target, key) {
    if (key) {
      setMetadataSchema(schema, target.constructor, key);
    } else {
      setMetadataSchema(schema, target, target.name);
    }
  };
}

exports.JSONSchema = JSONSchema;

function getMetadataSchema(target, key) {
  return Reflect.getMetadata(SCHEMA_KEY, target.constructor, key) || {};
}

exports.getMetadataSchema = getMetadataSchema;

function setMetadataSchema(value, target, key) {
  return Reflect.defineMetadata(SCHEMA_KEY, value, target, key);
}